import constants from 'constants/ui.js';

export const setOrUpdateMasqueradeMode = payload => {
  return {
    type: constants.MASQUERADE_MODE_SET_OR_UPDATE,
    payload,
  };
};

export const unsetMasqueradeMode = () => {
  return {
    type: constants.MASQUERADE_MODE_UNSET,
  };
};

export const setMasqueradeModeSettings = payload => {
  return {
    type: constants.MASQUERADE_MODE_SETTINGS_SET,
    payload,
  };
};

export const unsetMasqueradeModeSettings = () => {
  return {
    type: constants.MASQUERADE_MODE_SETTINGS_UNSET,
  };
};

export const setOrUpdateNumberIndicator = payload => {
  return {
    type: constants.NUMBER_INDICATOR_SET_OR_UPDATE,
    payload,
  };
};
